import { Facebook, Instagram, LinkedIn, X } from '@mui/icons-material'
import React from 'react'

import TikTok from '~/assets/images/misc/tiktok.svg?react'
import {
  EPartnerSocialLinksPlatform,
  TPartnerSocialLinks,
} from '~/features/partners/models'

const getSocialLinkIcon = (socialPlatform: EPartnerSocialLinksPlatform) => {
  switch (socialPlatform) {
    case EPartnerSocialLinksPlatform.facebook:
      return <Facebook />
    case EPartnerSocialLinksPlatform.instagram:
      return <Instagram />
    case EPartnerSocialLinksPlatform.linkedin:
      return <LinkedIn />
    case EPartnerSocialLinksPlatform.x:
      return <X />
    case EPartnerSocialLinksPlatform.tiktok:
      return <TikTok />
    default:
      return ''
  }
}

type TSocialDetails = {
  icon: React.ReactNode
  path: string
}

const getSocialDetails = (
  socialLinks: TPartnerSocialLinks[],
): TSocialDetails[] => {
  return socialLinks
    .map(({ platform, url }) => {
      const icon = getSocialLinkIcon(platform)
      if (!icon) return null
      return { icon, path: url }
    })
    .filter(Boolean) as TSocialDetails[]
}

export default getSocialDetails
